export const REGIONS = [
  { value: "WEST", label: "West Pune" },
  { value: "EAST", label: "East Pune" },
  { value: "NORTH", label: "North Pune" },
  { value: "SOUTH", label: "South Pune" },
  { value: "CENTRAL", label: "Prime / Central Pune" },
];

export const DEVELOPERS = [
  "Kohinoor Group", "Kolte-Patil Developers", "Gera Developments", "Nyati Group",
  "Ceratec Group", "Mahindra Lifespaces", "Krisala x Hiranandani", "Saheel Properties",
  "Siddhi Buildcon", "VTP Realty", "Godrej Properties", "Austin Realty",
  "Mantra Properties", "Bhondve Group",
];

export const PROJECT_STATUS = [
  { label: "New Launch", value: "new-launch" },
  { label: "Under Construction", value: "under-construction" },
  { label: "Ready to Move", value: "ready-to-move" },
];

export const PUNE_LOCATIONS = [
  "Wakad", "Baner", "Balewadi", "Hinjewadi", "Aundh", "Pimple Saudagar",
  "Kharadi", "Viman Nagar", "Kalyani Nagar", "Koregaon Park", "Hadapsar",
  "Kothrud", "Bavdhan", "Kondhwa", "NIBM", "Wagholi", "Ravet", "Tathawade",
  "Pimpri-Chinchwad",
];

export const CONFIG_OPTIONS = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5 BHK", "Office", "Shop"];

export const PROPERTY_TYPES = [
  { label: "Residential", value: "residential" },
  { label: "Commercial", value: "commercial" },
];

export const STATUS_OPTIONS = [
  { label: "Ready to Move", value: "ready-to-move" },
  { label: "Under Construction", value: "under-construction" },
  { label: "New Launch", value: "new-launch" },
];

export const CATEGORY_OPTIONS = [
  { label: "Residential", value: "residential", type: "residential" },
  { label: "Commercial", value: "commercial", type: "commercial" },
  { label: "Luxury", value: "luxury" },
  { label: "New Projects", value: "new-projects" },
  { label: "Ready to Move", value: "ready-to-move" },
  { label: "Investment", value: "investment" },
];

// budget values are in Crores (to match backend price_min/price_max floats)
export const BUDGET_MIN_OPTIONS = [
  { label: "No Min", value: "" },
  { label: "₹50 L", value: "0.5" },
  { label: "₹75 L", value: "0.75" },
  { label: "₹1 Cr", value: "1" },
  { label: "₹1.5 Cr", value: "1.5" },
  { label: "₹2 Cr", value: "2" },
  { label: "₹3 Cr", value: "3" },
];

export const BUDGET_MAX_OPTIONS = [
  { label: "No Max", value: "" },
  { label: "₹75 L", value: "0.75" },
  { label: "₹1 Cr", value: "1" },
  { label: "₹1.5 Cr", value: "1.5" },
  { label: "₹2 Cr", value: "2" },
  { label: "₹3 Cr", value: "3" },
  { label: "₹5 Cr", value: "5" },
  { label: "₹8 Cr+", value: "10" },
];

export const REQUIREMENT_TYPES = [
  "Residential", "Commercial", "Investment", "Plot / Land", "Second Home", "Not Sure — Help Me Decide",
];

export const LOCATION_PAGES = [
  { name: "Wakad", slug: "wakad" },
  { name: "Hinjewadi", slug: "hinjewadi" },
  { name: "Baner", slug: "baner" },
  { name: "Balewadi", slug: "balewadi" },
  { name: "Kharadi", slug: "kharadi" },
  { name: "Viman Nagar", slug: "viman-nagar" },
  { name: "Wagholi", slug: "wagholi" },
  { name: "Hadapsar", slug: "hadapsar" },
  { name: "Undri", slug: "undri" },
];

export const PREFERRED_REGION_OPTIONS = [
  { value: "WEST", label: "West Pune" },
  { value: "EAST", label: "East Pune" },
  { value: "NORTH", label: "North Pune" },
  { value: "SOUTH", label: "South Pune" },
  { value: "CENTRAL", label: "Central / Prime Pune" },
  { value: "ANY", label: "Anywhere in Pune" },
];

export const PURPOSE_OPTIONS = ["To live in", "Investment", "Rental income", "Second home", "Business use"];
export const TIMELINE_OPTIONS = ["Immediately", "Within 3 months", "3-6 months", "6-12 months", "Just exploring"];

export const STATUS_LABEL = {
  "ready-to-move": "Ready to Move",
  "under-construction": "Under Construction",
  "new-launch": "New Launch",
};

export function formatCr(v) {
  if (v == null) return "Price on request";
  if (v >= 1) return `₹${Number(v).toFixed(2)} Cr`;
  return `₹${Math.round(Number(v) * 100)} L`;
}

export function priceRange(p) {
  if (p?.price_display) return p.price_display;
  if (p?.price_min != null) return `${formatCr(p.price_min)} - ${formatCr(p.price_max)}`;
  return "Price on request";
}

export function waLink(number, message) {
  const digits = String(number || "").replace(/\D/g, "");
  const n = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${n}?text=${encodeURIComponent(message)}`;
}
